<template>
  <div>
    <p>
      Thank you for your purchase! You will receive two emails shortly from
      Recreation.gov with your receipt and pass. Enjoy your visit!
    </p>
    <br />
    <h2>Order Summary</h2>
    <order-summary />

    <div>
      <h2>Order Details</h2>
      <PassList allowPassRemoval="false" :agencyName="agencyName" />
    </div>

    <receipt-buttons :downloadUrl="downloadUrl" />
  </div>
</template>

<script>
import PassList from "@/components/Passes/PassList.vue";
import OrderSummary from "@/components/Passes/OrderSummary.vue";
import ReceiptButtons from "@/components/Receipt/ReceiptButtons.vue";
export default {
  props: ["downloadUrl", "agencyName"],
  name: "ReceiptOrderComplete",
  components: {
    PassList,
    OrderSummary,
    ReceiptButtons
  }
};
</script>
